import clsx from 'clsx';
import Image from 'next/image';
import type React from 'react';

interface SelectionItemProps {
	image?: string;
	label: string;
	selected: boolean;
	onClick: () => void;
}

export const SelectionItem: React.FC<SelectionItemProps> = ({
	image,
	label,
	selected,
	onClick,
}) => {
	return (
		<div
			className="flex items-center px-4 rounded-[0.625rem] h-12.5 border border-grey-3 cursor-pointer hover:bg-grey-4 transition-colors"
			onClick={onClick}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					onClick();
				}
			}}
			role="button"
			tabIndex={0}
		>
			<div className="flex items-center flex-1 gap-3.75">
				{image && (
					<div className="w-7.5 h-7.5 relative">
						<Image src={image} alt={label} fill className="object-contain" />
					</div>
				)}
				<span className="text-sm font-medium text-grey-1">{label}</span>
			</div>
			<div
				className={clsx(
					'w-3.75 h-3.75 flex items-center justify-center rounded-full border border-grey-3',
					selected ? 'bg-green-400' : '',
				)}
			/>
		</div>
	);
};
